import React, {Component} from "react";
import PropTypes from "prop-types";
import * as _ from "lodash"
import GrudLogo from "./../widgets/grudLogo/grudLogo";
import omniChannelDiagramStyles from "./omniChannelDiagram.module.pcss";

const OmniChannelDiagram = ({backgroundColor, borderWidth, circleColor, grudLogoColor, grudLogoWidth}) => {

  const omniChannelDiagramInlineStyles = {
    backgroundColor: backgroundColor,
  };

  const circleStyles = {
    ..._.isArray(circleColor) ? {"backgroundImage": `linear-gradient(${circleColor[0]},${circleColor[1]})`} : null,
    ...!_.isArray(circleColor) ? {"background": circleColor} : null
  };

  const calculateBorder = `calc(100% - ${borderWidth})`;

  const innerCircleStyles = {
    backgroundColor: omniChannelDiagramInlineStyles.backgroundColor,
    width: calculateBorder,
    height: calculateBorder
  };

  const textElementsStyles = {
    backgroundColor: backgroundColor
  };

  return (
    <div style={omniChannelDiagramInlineStyles} className={omniChannelDiagramStyles.omniChannelDiagram}>
      <div style={circleStyles} className={omniChannelDiagramStyles.circle}>
        <div style={innerCircleStyles}>
          <GrudLogo color={grudLogoColor} width={grudLogoWidth} />
        </div>
      </div>
      <span style={{
        ...textElementsStyles,
      }} className={omniChannelDiagramStyles.mdm}>MDM</span>
      <span style={textElementsStyles} className={omniChannelDiagramStyles.pim}>PIM</span>
      <span style={{
        ...textElementsStyles,
      }} className={omniChannelDiagramStyles.cms}>CMS</span>
      <span style={textElementsStyles} className={omniChannelDiagramStyles.dam}>DAM</span>
    </div>
  )
};

OmniChannelDiagram.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  borderWidth: PropTypes.string.isRequired,
  circleColor: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  grudLogoColor: PropTypes.string,
  grudLogoWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default OmniChannelDiagram;


// WEBPACK FOOTER //
// ./src/components/ominiChannelDiagram/omniChannelDiagram.js